// extracted by mini-css-extract-plugin
export default {"image":"hX-z","loaded":"iX-z"};